export const foundOptionsFallback: string[] = [
    "Internet",
    "Mond tot mond",
    "KHN",
    "Nieuwsbrief",
    "Eerder cursus gevolgd",
    "SVH",
    "Horecabeurs",
    "SBB",
    "Curio",
    "AI (ChatGPT)",
    "LinkedIn",
    "Social Media",
    "niet bekend/overig"
]
